export const environment = {
  production: true,
  baseUrl: '/api',
  apiGatewayUrl: '',
};
